import React from "react";
import style from "./style.module.scss"
import SearchBar from "../search";
import { useNavigate } from "react-router-dom";

const TopBar = ()=>{
    const navigate = useNavigate()
    const gotToHome = ()=>{
        console.log("clicked")
        navigate("/users")
    }
    return (
    <div className={style.topbar} >
        <div className={style.logo} onClick={gotToHome} >
            <img  src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" alt="github logo" />
        </div>
        <SearchBar />
    </div>)

}

export default TopBar;